
export default {
  name: 'DiscountCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Why is it important to calculate discounts?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Calculating the discount price is essential, as it helps you determine the deal that applies precisely to the product or service's discounted price."
        }
      },{
        "@type": "Question",
        "name": "How do you calculate discounts without a calculator?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Without using a calculator, you can still calculate promotional discounts by following these steps: Step 1: Determine the discount rate and original price of goods and finished products. Step 2: Convert the ratio as a percentage. Step 3: Multiply the balance by the actual cost to calculate the discount. Step 4: Calculate the selling price by subtracting the actual cost from the deal found in step 3."
        }
      },{
        "@type": "Question",
        "name": "What does a 30% discount mean?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The original price of an item is $100. When you have a 30% discount, the remaining value you pay to buy this item is $70. So, you saved $30 on this deal."
        }
      },{
        "@type": "Question",
        "name": "What is $24.99 with 30% off?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "To determine the sales discount amount, multiply the discount rate by the item's price. In this example, we have: Discount sale price=$24.99 * 30% =$7,50."
        }
      }]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        price: null,
        discount: null
      })
    }
  },
  methods: {
    onDiscountCalculator() {
        this.form.post(`/tool/discount-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.price    = 59;
        this.form.discount = 15;
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
